import React, { FormEvent, useEffect, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import './styles/SignOn.scss'

import { createDocument } from '../document/redux/actions'
import { authenticate, createUser } from 'panel/user/redux/actions'
import { maskCNPJ, maskCPF, maskNumber } from 'util/masks'

const initialState = {
  personType: 'STANDARD' as const,
  docType: '',
  docNumber: '',
  firstName: '',
  lastName: '',
  email: '',
  username: '',
  password: '',
  _password: ''
}
const SignUp: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const [isFetching, setFetching] = useState(false)
  const [document, setDocument] = useState({ type: 'RG', value: '' })
  const [form, setForm] = useState(initialState)

  useEffect(() => {
    setForm(form => ({ ...form, docType: (form.personType === 'STANDARD' ? 'CPF' : 'CNPJ') as 'CPF' }))
  }, [form.personType])

  async function handleForm (e: FormEvent): Promise<void> {
    e.preventDefault()
    setFetching(true)
    await createUser(form as any)(dispatch).then(res => {
      if (res?.status === 'success') {
        const { email, username, password } = form
        authenticate({ username: username || email, password })(dispatch)
          .then(async res => {
            if (res.status === 'success' && res.data?.token) {
              await createDocument(Number(res.data.user.person.id), document)(dispatch)
              history.push('/panel')
            }
          })
      }
    })
    setFetching(false)
  }

  const logo = `${process.env.PUBLIC_URL}/img/logo.png`
  const logoWhite = `${process.env.PUBLIC_URL}/img/logo-white.png`

  const isStandard = form.personType === 'STANDARD'

  return (
    <div className="row sign-on">
      <div className="row">
        <div className="row side-left">
          <img width={350} className="margin-top-16" src={logoWhite} alt="Logo" />
        </div>
        <form onSubmit={handleForm} className="row side-right">
          <img className="padding-16 margin-tb-16 hidden-desk" src={logo} alt="Logo" />
          <h1 className="text-center">Faça seu cadastro</h1>

          <div className="form-control col-6">
            <label>Tipo Cadastro</label>
            <select
              required
              value={form.personType}
              onChange={(e): void => setForm({ ...form, personType: e.target.value as 'STANDARD' })}
            >
              <option value="STANDARD">Pessoa Física</option>
              <option value="BUSINESS">Pessoa Jurídica</option>
            </select>
          </div>
          <div className="form-control col-6">
            <label>{ form.docType }</label>
            <input
              type="text"
              value={form.docNumber}
              onChange={(e): void => {
                setForm({
                  ...form,
                  docNumber: isStandard ? maskCPF(e.target.value) : maskCNPJ(e.target.value)
                })
              }}
              required
            />
          </div>

          {/* Inputs */}
          <div className="form-control col-6">
            <label>{isStandard ? 'Primeiro Nome' : 'Razão Social'}</label>
            <input
              type="text"
              value={form.firstName}
              onChange={(e): void => setForm({ ...form, firstName: e.target.value })}
              required={true}
            />
          </div>
          <div className="form-control col-6">
            <label>{isStandard ? 'Sobrenome' : 'Nome Fantasia'}</label>
            <input
              type="text"
              value={form.lastName}
              onChange={(e): void => setForm({ ...form, lastName: e.target.value })}
              required={true}
            />
          </div>
          <div className="form-control col-6">
            <label>E-mail</label>
            <input
              type="text"
              value={form.email}
              onChange={(e): void => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>
          <div className="form-control col-6">
            <label>{ isStandard ? 'RG' : 'I.E.' }</label>
            <input
              type="text"
              value={document.value || ''}
              onChange={(e): void => {
                setDocument({ type: isStandard ? 'RG' : 'IE', value: maskNumber(e.target.value) })
              }}
              required
            />
          </div>
          <div className="form-control col-6">
            <label>Senha</label>
            <input
              type="password"
              value={form.password}
              onChange={(e): void => setForm({ ...form, password: e.target.value })}
              autoComplete="new-password"
              required
            />
          </div>
          <div className="form-control col-6">
            <label>Confirmar Senha</label>
            <input
              type="password"
              value={form._password}
              onChange={(e): void => setForm({ ...form, _password: e.target.value })}
              autoComplete="new-password"
              required
            />
          </div>

          {/* Buttons */}
          <div className="form-control margin-top-16">
            <button className="button primary col-12" disabled={isFetching}>
              { isFetching ? 'Realizando Cadastro. Aguarde...' : 'Criar Conta' }
            </button>

            <NavLink to="/sign-in" className="button col-12 margin-top-8">
              Já possui conta? Fazer login.
            </NavLink>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SignUp
